import { Button, Checkbox, Input, Popup, SafeArea, Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import style from "./index.module.scss";
import CloseIcon from "../assets/close.svg";
import Countdown from "../components/countdown";
import {
  sendVerifyCode,
  validateVerifyCode,
  verifySmsUrl,
} from "../../../network/octopusApi";

const PhoneVerify = () => {
  const { token } = useParams<{ token: string }>();
  const history = useHistory();

  const [agreeVisible, setAgreeVisible] = useState<boolean>(false);
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [verifyCode, setVerifyCode] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [isAgree, setIsAgree] = useState(true);

  // 报错信息处理
  const handleErrMsg = (msg) => {
    const arr = msg.split(";");
    return arr[0];
  };

  // 获取验证码
  const handleGetCode = async () => {
    if (!phoneNumber) {
      Toast.show("手机号未输入");
      return;
    }
    if (!/^1[3456789]\d{9}$/.test(phoneNumber)) {
      Toast.show("手机号不正确");
      return;
    }
    const res = await sendVerifyCode(token, { phone: phoneNumber });
    const { data, msg } = res.data;
    if (!data) {
      Toast.show(handleErrMsg(msg));
      return;
    }
    setIsCodeSent(true);
  };

  // 倒计时结束
  const handleCountdown = () => {
    setIsCodeSent(false);
  };

  // 点击下一步
  const handleSubmit = () => {
    sessionStorage.setItem("phone", phoneNumber);
    sessionStorage.setItem("code", verifyCode);
    history.replace(`/octopus/upload/${token}`);
  };

  useEffect(() => {
    // 校验
    const handleVerify = async () => {
      let flag = true;
      if (phoneNumber.length === 11 && verifyCode.length === 6) {
        const params = {
          phone: phoneNumber,
          code: verifyCode,
        };
        const res = await validateVerifyCode(token, params);
        const { data, msg } = res.data;
        if (data) {
          flag = false;
          Toast.show("校验成功");
        } else {
          Toast.show(handleErrMsg(msg));
        }
      }
      setBtnDisabled(flag);
    };
    handleVerify();
  }, [phoneNumber, token, verifyCode]);

  useEffect(() => {
    document.title = "身份验证";
    // 校验链接有效性
    const handleVerifyUrl = async () => {
      const isValid = /^[\u0020-\u007F]+$/.test(token);
      if (!isValid) {
        history.replace(`/octopus/error/${token}`);
        return;
      }
      try {
        const res = await verifySmsUrl(token);
        const { data } = res.data;
        if (!data) {
          history.replace(`/octopus/error/${token}`);
        }
      } catch {
        history.replace(`/octopus/error/${token}`);
      }
    };
    handleVerifyUrl();
  }, [history, token]);

  return (
    <div className={style.phoneVerifyPage}>
      <div className={style.inputWrap}>
        <Input
          placeholder="请输入手机号码"
          type="tel"
          maxLength={11}
          value={phoneNumber}
          onChange={(v) => setPhoneNumber(v)}
        />
      </div>
      <div className={style.inputWrap}>
        <Input
          placeholder="请输入验证码"
          type="tel"
          maxLength={6}
          value={verifyCode}
          onChange={(v) => setVerifyCode(v)}
        />
        {!isCodeSent ? (
          <div className={style.codeBtn} onClick={handleGetCode}>
            获取验证码
          </div>
        ) : (
          <Countdown onFinish={handleCountdown} />
        )}
      </div>
      <div className={style.checkboxWrap}>
        <Checkbox checked={isAgree} onChange={(v) => setIsAgree(v)} />
        <div>勾选即同意</div>
        <div
          className={style.agreementBtn}
          onClick={() => setAgreeVisible(true)}
        >
          《用户协议》
        </div>
      </div>
      <div className={style.footer}>
        <div className={style.tip}>请在12小时内完成身份验证和文件上传</div>
        <Button
          block
          size="large"
          onClick={handleSubmit}
          disabled={btnDisabled || !isAgree}
        >
          下一步
        </Button>
        <SafeArea position="bottom" />
      </div>
      <Popup
        visible={agreeVisible}
        onMaskClick={() => {
          setAgreeVisible(false);
        }}
        bodyClassName={style.agreePopup}
      >
        <div className={style.header}>
          <div className={style.title}>用户协议</div>
          <div
            className={style.closeBtn}
            onClick={() => setAgreeVisible(false)}
          >
            <img src={CloseIcon} alt="closeIcon" />
          </div>
        </div>
        <div className={style.content}>
          您理解并同意，为便于我们帮助您尽快解决问题，或记录相关问题的处理方案及结果，您将上传提交相关证明材料，材料内容仅用于本次问题处理，不用于任何其他用途。如其中可能涉及您或他人的个人信息，请您更加谨慎地考虑，请勿上传自认为个人隐私的信息。如您选择上传的材料内容涉及他人的个人信息，您应在上传前征得他人的同意。同时，您承诺您对所上传材料内容的真实、准确、合法性负责，确保其中无任何违反法律法规及侵犯第三方合法权益的内容，否则由此引发的一切纠纷及法律责任均由您自行承担。
        </div>
      </Popup>
    </div>
  );
};

export default PhoneVerify;
